module.exports = __webpack_public_path__ + "img/電気回路_1_10_1.4dcd7b58.png";